const CONSTANTS = {
  ROLES: {
    ADMIN: "Admin",
    PSYCHOLOGIST: "Psychologist",
  },
  ROLE_ID: {
    PATIENT: 1,
    PSYCHOLOGIST: 2,
    ADMIN: 3,
    LEADPSYCHOLOGIST: 4,
    TEAMLEAD: 5,
    CSLEAD: 6,
    CSAGENT: 7,
    FINANCE: 8,
    MARKETING: 9,
    DEVELOPER: 10,
  },
  PLATFORM: {
    WEB: "web",
    IOS: "iOS",
    ANDROID: "Android",
  },
  EXLUDE_PSYCHOLOGIST_ID: "-1",
  LOGOUT_TIMEOUT: 1000 * 60 * 60,
  SEARCH_TIMEOUT: 1000,
  NOTIFICATION_TIMEOUT: 4000,
  FETCH_INTERVAL: 15000,
  CAN_CONNECT_BEFORE: 0,
  GOT_BOOKINGS: "GOT_BOOKINGS",
  GOT_USER_PERIODS: "GOT_USER_PERIODS",
  IS_APP: "IS_APP",
  NO_PSYCHOLOGIST: "NO_PSYCHOLOGIST",
  GOT_TEMPLATES: "GOT_TEMPLATES",
  DEFAULT_TIME_FORMAT: "HH:mm",
  SELECTED_SLOT: "SELECTED_SLOT",
  SELECTED_PATIENT_MESSAGES: "SELECTED_PATIENT_MESSAGES",
  MESSAGE_TEMPLATES: "MESSAGE_TEMPLATES",
  MARKET: "MARKET",
  NL: "NL",
  SE: "SE",
  REVISIT: "revisit",
  NEW_VISIT: "new_visit",
  LONG_VISIT: "long_visit",
  BLOCKER_TEMPLATE: "blocker",
  WORK_HOURS: "work_hours",
  SEARCH: "SEARCH",
  DEMO: "*******",
  SUPERVISION_TEMPLATE: "supervision",
  DIALOGS: {
    SLOT: "SLOT",
    REFUND: "REFUND",
    BLOCKER: "BLOCKER",
    WORK_HOURS: "WORK_HOURS",
    SUPERVISION: "SUPERVISION",
    WRITTEN_FEEDBACK: "WRITTEN_FEEDBACK",
  },
  BOOKING_STATUS: {
    OPEN: "OPEN",
    BOOKED: "BOOKED",
    CANCELED: "CANCELED",
    LATE_CANCELED: "LATE_CANCELED",
    UNAVAILABLE: "UNAVAILABLE",
    NO_SHOW: "NO_SHOW",
    ORGANIZER_NO_SHOW: "ORGANIZER_NO_SHOW",
    NO_SHOW_ALL: "NO_SHOW_ALL",
    TOTAL: "TOTAL",
  },
  BOOKINGS_TIME_STATE: {
    UPCOMING: "UPCOMING",
    PAST: "PAST",
  },
  PATIENT_PROMOCODES: {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
  },
  STATS_STATUS: {
    OPEN: "OPEN",
    BOOKED: "BOOKED",
    CANCELED: "CANCELED",
    LATE_CANCELED: "LATE_CANCELED",
    NO_SHOW: "NO_SHOW",
    ORGANIZER_NO_SHOW: "ORGANIZER_NO_SHOW",
    NO_SHOW_ALL: "NO_SHOW_ALL",
    TOTAL: "TOTAL",
  },
  UPDATABLE_BOOKING_STATUS: {
    BOOKED: "BOOKED",
    CANCELED: "CANCELED",
    LATE_CANCELED: "LATE_CANCELED",
    NO_SHOW: "NO_SHOW",
    ORGANIZER_NO_SHOW: "ORGANIZER_NO_SHOW",
    NO_SHOW_ALL: "NO_SHOW_ALL",
  },
  UPDATABLE_BOOKING_STATUS_DK_PSYCHOLOGIST: {
    BOOKED: "BOOKED",
    NO_SHOW: "NO_SHOW",
  },
  ACTIVE_TREATMENT: {
    IN_TREATMENT: "IN_TREATMENT",
  },
  END_TREATMENT_REASONS: {
    TREATMENT_COMPLETED: "TREATMENT_COMPLETED",
    DOES_NOT_COMPLY_WITH_USER_AGREEMENTS:
      "DOES_NOT_COMPLY_WITH_USER_AGREEMENTS",
    SEVERAL_MISSED_VISITS: "SEVERAL_MISSED_VISITS",
    DID_NOT_MEET_CARE_CRITERIA: "DID_NOT_MEET_CARE_CRITERIA",
    END_ON_PATIENTS_REQUEST: "END_ON_PATIENTS_REQUEST",
    PATIENT_REFERRED_TO_EXTERNAL_CARE: "PATIENT_REFERRED_TO_EXTERNAL_CARE",
    REFERRED_TO_COLLEAGUE: "REFERRED_TO_COLLEAGUE",
    TREATMENT_NOT_APPLICABLE: "TREATMENT_NOT_APPLICABLE",
  },
  TREATMENT_EVENT_TYPE: {
    TREATMENT_START: "TREATMENT_START",
    TREATMENT_END: "TREATMENT_END",
  },
  PATIENT_BOOKING_TYPES: {
    ONGOING: "ongoing",
    UNSCHEDULED: "unscheduled",
    NEW: "new",
    UPCOMING_WITH_COLLEAGUE: "upcoming_with_colleague",
  },
  MINIMUM_PATIENT_AGE: 18,
  PROGRAMME_STATUS: {
    NO_ASSIGNMENT: "NO_ASSIGNMENT",
    NOT_STARTED: "NOT_STARTED",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED: "COMPLETED",
  },
  CONTENT_TYPE: {
    TEXT: "TEXT",
    IMAGE_URL: "IMAGE_URL",
    LIST: "LIST",
    LINK: "LINK",
    VIDEO_URL: "VIDEO_URL",
    INPUT_TEXT: "INPUT_TEXT",
    INPUT_TEXTAREA: "INPUT_TEXTAREA",
  },
  PERMISSIONS: {
    READ_VERSIONS: "READ_VERSIONS",
    WRITE_VERSIONS: "WRITE_VERSIONS",
    USER_FLAGGED: "USER_FLAGGED",
    BETA_TESTER: "BETA_TESTER",
    EXTRACT_ICBT_FEE: "EXTRACT_ICBT_FEE",
    USER_SEARCH: "USER_SEARCH",
    USER_BLOCK: "USER_BLOCK",
    DELETE_USER: "DELETE_USER",
    USER_PAYMENTS: "USER_PAYMENTS",
    EDIT_PATIENT_DETAILS: "EDIT_PATIENT_DETAILS",
  },
  IMPLEMENT_FEATURES: {
    BANK_ID: "BANK_ID",
    COGNITO: "COGNITO",
    MESSAGING_TO_PATIENT: "MESSAGING_TO_PATIENT",
    REFERRAL_CERTIFICATE: "REFERRAL_CERTIFICATE",
    END_TREATMENT: "END_TREATMENT",
    ASSIGN_ICBT: "ASSIGN_ICBT",
    MAINTENANCE: "MAINTENANCE",
  },
  DATE_FORMAT: {
    DEFAULT_DATE_FORMAT: "yyyy-MM-dd",
    DAY_NAME_DATE_FORMAT: "EEE d",
    YEAR_NAME_DATE_FORMAT: "yyyy-MM-dd HH:mm",
    YEAR_NAME_DATE_SECONDS_FORMAT: "yyyy-MM-dd HH:mm:ss",
    MONTH_NAME_DATE_FORMAT: "MMMM",
    YEAR_DATE_FORMAT: "yyyy",
    DAY_DAY: "dd",
    DATE_NUMBER: "dd",
  },
  NATIONAL_IDENTITY: "nationalIdentity",
  BSN: "bsn",
  TIME_ZONE_STOCKHOLM: "Europe/Stockholm",
  SEARCH_TERMS: {
    FIRSTNAME: "FIRSTNAME",
    LASTNAME: "LASTNAME",
    NATIONAL_IDENTITY: "NATIONAL_IDENTITY",
    EMAIL: "EMAIL",
    USER_ID: "USER_ID",
    TREATMENT_STATUS: "TREATMENT_STATUS",
    FILTER: "FILTER",
  },
  MEETING_METHOD: {
    VIDEO: "VIDEO",
    PHONE: "PHONE",
  },
  MEETING_WINDOW_NAME: {
    VIDEO: "MINDLER_VIDEO",
  },
  VIDEO_STREAM_2: {
    PATH: "/video/index.html",
  },
  PATIENT_CARD_TABS: {
    BOOKINGS: "BOOKINGS",
    PROMOCODES: "PROMOCODES",
    ACTIONS: "ACTIONS",
    ICBT: "ICBT",
  },
  VERSION_CHECK_FREQUENCY: 300000,
  HOUR_PER_DAY: 24,
  CERTIFICATE: "certificate",
  REFERRAL: "referral",
  CALENDAR: {
    SHORT_MONTH: [
      { key: 0, label: "JAN" },
      { key: 1, label: "FEB" },
      { key: 2, label: "MAR" },
      { key: 3, label: "APR" },
      { key: 4, label: "MAY_SHORT" },
      { key: 5, label: "JUNE_SHORT" },
      { key: 6, label: "JULY_SHORT" },
      { key: 7, label: "AUG" },
      { key: 8, label: "SEPT" },
      { key: 9, label: "OCT" },
      { key: 10, label: "NOV" },
      { key: 11, label: "DEC" },
    ],
  },
  SELECTED_PATIENT_QUESTIONNAIRES: "SELECTED_PATIENT_QUESTIONNAIRES",
  POST_PATIENT_QUESTIONNAIRE_REQUEST: "POST_PATIENT_QUESTIONNAIRE_REQUEST",
  GET_PATIENT_QUESTIONNAIRE_REQUEST: "GET_PATIENT_QUESTIONNAIRE_REQUEST",
  DELETE_PATIENT_QUESTIONNAIRE_REQUEST: "DELETE_PATIENT_QUESTIONNAIRE_REQUEST",
  GET_PATIENT_QUESTIONNAIRE_REQUEST_FAILURE:
    "GET_PATIENT_QUESTIONNAIRE_REQUEST_FAILURE",
  SELECTED_PATIENT_QUESTIONNAIRES_FAILURE:
    "SELECTED_PATIENT_QUESTIONNAIRES_FAILURE",
  QUESTIONNAIRES: "QUESTIONNAIRES",
  QUESTIONNAIRE_CONTENT: "QUESTIONNAIRE_CONTENT",
  UPDATE_PATIENT_REQUEST: "UPDATE_PATIENT_REQUEST",
  QUESTIONNAIRE_SCORE_STATUS: {
    NO: "No risk",
    MILD: "Mild risk",
    MODERATE: "Moderate risk",
    SEVERE: "Severe risk",
  },
  FEE: "FEE",
  NO_FEE: "NO_FEE",
  SLOT_TEMPLATES: {
    PRE_INTAKE: "pre_intake",
    NEW_VISIT: "new_visit",
    INTAKE_REPORT_WRITING: "intake_report_writing",
    ROUTINE_OUTCOME_MONITORING: "routine_outcome_monitoring",
    REVISIT: "revisit",
    CONSULT_JOURNAL_NOTE_WRITING: "consult_journal_note_writing",
    MULTI_DISCIPLINARY_DISCUSSION: "multi_disciplinairy_discussion",
    DISCUSSION_WITH_NON_MINDLER_CAREGIVER:
      "discussion_with_non_mindler_caregiver",
    EMAIL_OR_DIGITAL_CONTACT: "email_or_digital_contact",
    REPORTING: "reporting",
    ORGANISING_PATIENTS_CASE: "organising_patients_case",
    ADVISORY_CONSULT: "advisory_consult",
    ADVISORY_CONSULT_JOURNAL_ENTRY: "advisory_consult_journal_entry",
    DIAGNOSTICS: "diagnostics",
    DIAGNOSTICS_JOURNAL_ENTRY: "diagnostics_journal_entry",
    ICBT: "iKBT",
    TECH_TEST: "tech_test",
    COUPLES_THERAPY: "couples_therapy",
    FEEDBACK: "feedback",
    CHAT_DROP_IN: "chat_drop_in",
    BLOCKER: "blocker",
    SUPERVISION: "supervision",
    EMDR: "emdr",
    WORK_HOURS: "work_hours",
    LONG_VISIT: "long_visit",
    SHORT_VISIT: "short_visit",
    MINDLER_ACADEMY: "mindler_academy",
    DAILY_HUB: "daily_hub",
    CLINICAL_SUPERVISION: "clinical_supervision",
    LIVE_MANAGEMENT_30: "live_management_30",
    LIVE_MANAGEMENT_60: "live_management_60",
    ADHD_SCREENING: "adhd_screening",
    CONTRACTED_OTHER: "contracted_other",
    PARENTAL_SUPPORT: "parental_support",
    APPOINTMENT_50: "appointment_50",
    EVALUATION: "evaluation",
  },
  PSYCHOLOGIST_ROW_COMBINATION_KEYS: {
    EDITABLE_NAME: "editableName",
    EDITABLE_PHONE_NUMBER_AND_HSA: "editablePhoneNumberAndHsa",
    UNEDITABLE_NATIONAL_ID_AND_EMAIL: "uneditableNationalIdAndEmail",
    UNEDITABLE_EMAIL: "uneditableEmail",
    EDITABLE_PHONE_AND_EDITABLE_ADELI: "editablePhoneAndEditableAdeli",
    EDITABLE_PHONE_AND_UNEDITABLE_EMAIL: "editablePhoneAndUneditableEmail",
    EDITABLE_BIG_CODE: "editableBigCode",
  },
  PROMOCODE_CATEGORIES: {
    B2B: "B2B",
    B2B_MEMBERSHIP: "B2B_MEMBERSHIP",
    BUNDLE: "BUNDLE",
    CS: "CS",
    INTERNAL: "INTERNAL",
    MARKETING: "MARKETING",
    OTHER: "OTHER",
  },
  BOOKINGS_TABLE_NAME: {
    CANCELLED_BOOKINGS: "CANCELLED_BOOKINGS",
  },
  PSYCHOLOGIST: {
    ABSENCE_STATUS: {
      ACTIVE: "active",
      ON_LEAVE: "absent",
    },
    EMPLOYMENT_TYPE: {
      PART_TIME: "part-time",
      FULL_TIME: "full-time",
    },
  },
  NO_VALUE: "--",
};

export default CONSTANTS;
